<template>
  <surveys-grid :items="quizzes" :page-title="pageTitle" @refresh="refresh"
                return-page="quizzes"
                :empty-text="$t('No quizzes')"/>
</template>

<script>
import {mapActions, mapState} from "vuex";
import PageTitle from "@/mixins/pageTitle";
import BeforeRoute from "@/mixins/beforeRoute";
import SurveysGrid from "@/components/quiz/SurveysGrid";

export default {
  name: "QuizzesPage",
  components: {SurveysGrid},
  mixins: [
    BeforeRoute('fetchQuizzes'),
    PageTitle('Quizy'),
  ],
  methods: {
    ...mapActions([
      'fetchUser',
      'fetchQuizzes'
    ]),
    refresh() {
      this.fetchQuizzes();
      this.fetchUser();
    },
  },
  computed: {
    ...mapState({
      quizzes: state => state.quizzes.quizzes,
    }),
  }
}
</script>

<style scoped>

</style>
